<template>
  <svg width="0" height="0" class="position-absolute">
    <symbol
      id="left"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 18L9 12L15 6"
        stroke="url(#paint0_linear_2128_1417)"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2128_1417"
          x1="5.568"
          y1="5.81527"
          x2="13.618"
          y2="18.0216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#184128" />
          <stop offset="1" stop-color="#051313" />
        </linearGradient>
      </defs>
    </symbol>

    <symbol
      id="speed"
      viewBox="0 0 153 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7" filter="url(#filter0_f_2107_36727)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M107.366 46.3893C108.338 45.3809 109.934 45.3847 110.849 46.4478C118.556 55.4052 123.427 67.0437 123.997 79.8473C124.058 81.2424 122.948 82.3757 121.585 82.3759H100.494C99.1311 82.3758 98.0348 81.2419 97.9443 79.8483C97.8248 78.0068 95.9931 76.8919 94.293 77.5007L75.9668 84.0629C73.7874 84.8026 71.2655 84.5387 69.783 82.6299C69.3106 82.0215 68.9153 81.3539 68.743 80.6868C68.5711 80.0201 68.5924 79.2391 68.7081 78.4679C69.0719 76.0463 71.1277 74.5097 73.3717 74.0201L89.8177 70.7167C92.9676 70.084 94.8384 66.692 93.2469 63.8353C92.6731 62.8053 92.7976 61.5003 93.611 60.6567L107.366 46.3893ZM76.022 78.6644C75.6492 77.2239 74.261 76.357 72.9214 76.7292C71.5817 77.1015 70.7971 78.5722 71.1687 80.013C71.541 81.4542 72.9293 82.3204 74.2693 81.9482C75.6094 81.5758 76.3943 80.1056 76.022 78.6644Z"
          fill="url(#paint0_linear_2107_36727)"
        />
        <path
          d="M31.5819 48.3552C32.4747 47.2157 34.1305 47.1739 35.1328 48.2133L38.095 51.2866C39.1235 52.3534 39.0202 54.0936 37.9516 55.1182C31.4383 61.3639 27.1671 70.0882 26.5339 79.8473C26.4435 81.2411 25.3473 82.3759 23.9843 82.3759H22.4136C21.0507 82.3759 19.9395 81.2427 20.0015 79.8473C20.5313 67.9342 24.7852 57.0299 31.5819 48.3552Z"
          fill="url(#paint1_linear_2107_36727)"
        />
        <path
          d="M74.4669 28.4471C85.9613 29.0037 96.48 33.429 104.844 40.4935C105.926 41.4079 105.965 43.0713 104.979 44.0939L92.2592 57.2866C91.2142 58.3703 89.4823 58.2629 88.4778 57.1397C84.4867 52.6772 79.4512 49.233 73.7735 47.2288C72.7325 46.8611 71.9997 45.8783 71.9995 44.7499V30.9171C71.9995 29.5203 73.1054 28.3811 74.4669 28.4471Z"
          fill="url(#paint2_linear_2107_36727)"
        />
        <path
          d="M66.1294 28.7309C67.5437 28.5664 68.7459 29.7283 68.7459 31.187V42.8296C68.7457 44.4114 67.3437 45.5994 65.8079 45.4415C64.6343 45.3208 63.4438 45.259 62.2396 45.2589C55.7489 45.2589 49.661 47.0508 44.4124 50.1841C43.3942 50.7919 42.0936 50.6619 41.2653 49.803L37.2603 45.6489C36.3045 44.6574 36.308 43.0553 37.3164 42.12C45.1519 34.8533 55.121 30.0122 66.1294 28.7309Z"
          fill="url(#paint3_linear_2107_36727)"
        />
      </g>
      <g filter="url(#filter1_f_2107_36727)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M107.366 46.3893C108.339 45.3809 109.935 45.3846 110.849 46.4479C118.556 55.4053 123.427 67.0429 123.997 79.8465C124.059 81.2418 122.948 82.3749 121.585 82.3751H100.494C99.131 82.375 98.0347 81.2412 97.9443 79.8475C97.8248 78.0064 95.9925 76.892 94.2928 77.5006L75.9668 84.0632C73.7873 84.8029 71.2654 84.538 69.783 82.6292C69.3106 82.0209 68.9154 81.354 68.743 80.6871C68.571 80.0204 68.5924 79.2393 68.7081 78.4681C69.0717 76.0463 71.1276 74.5089 73.3716 74.0193L89.8176 70.7159C92.9676 70.0832 94.8384 66.6912 93.2469 63.8344C92.6733 62.8045 92.7977 61.4993 93.611 60.6558L107.366 46.3893ZM76.022 78.6636C75.6491 77.2233 74.2609 76.3562 72.9214 76.7285C71.5818 77.1007 70.7973 78.5715 71.1687 80.0122C71.541 81.4534 72.9293 82.3196 74.2693 81.9474C75.6094 81.575 76.3943 80.1049 76.022 78.6636Z"
          fill="url(#paint4_linear_2107_36727)"
        />
        <path
          d="M31.5819 48.3552C32.4748 47.2157 34.1305 47.1738 35.1328 48.2133L38.095 51.2858C39.1235 52.3525 39.0202 54.0927 37.9517 55.1173C31.4381 61.3631 27.167 70.0881 26.5339 79.8475C26.4434 81.2412 25.3472 82.3751 23.9843 82.3751H22.4136C21.0506 82.3751 19.9395 81.2419 20.0015 79.8465C20.5313 67.9337 24.7854 57.0299 31.5819 48.3552Z"
          fill="url(#paint5_linear_2107_36727)"
        />
        <path
          d="M74.4668 28.4471C85.9613 29.0037 96.48 33.4291 104.844 40.4936C105.926 41.408 105.965 43.0714 104.979 44.094L92.2591 57.2867C91.2142 58.3702 89.4822 58.2629 88.4778 57.1398C84.4866 52.6772 79.4513 49.2331 73.7735 47.2289C72.7323 46.8612 71.9995 45.8776 71.9995 44.7489V30.9161C71.9998 29.5195 73.1055 28.3811 74.4668 28.4471Z"
          fill="url(#paint6_linear_2107_36727)"
        />
        <path
          d="M66.1294 28.7299C67.5435 28.5655 68.7456 29.7275 68.7459 31.186V42.8287C68.7459 44.4106 67.3438 45.5995 65.8079 45.4416C64.6343 45.3209 63.4438 45.259 62.2396 45.259C55.7489 45.259 49.661 47.0509 44.4124 50.1842C43.3942 50.7919 42.0935 50.6611 41.2653 49.8021L37.2603 45.649C36.3042 44.6574 36.3079 43.0545 37.3164 42.1191C45.1518 34.8525 55.1211 30.0112 66.1294 28.7299Z"
          fill="url(#paint7_linear_2107_36727)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M104.329 67.8042C105.77 67.5149 107.181 68.4305 107.561 69.9003C107.94 71.3701 107.16 72.8942 105.773 73.3909L75.9655 84.0637C75.2165 84.3179 74.427 84.4529 73.6532 84.4439C72.1758 84.4267 70.7555 83.883 69.7828 82.6307C69.3106 82.0224 68.915 81.3553 68.7427 80.6884C68.5707 80.0217 68.5923 79.2404 68.708 78.4692C68.9554 76.8214 69.9868 75.584 71.3274 74.8068C71.3693 74.7826 71.4111 74.7584 71.4535 74.735C71.642 74.6313 71.8365 74.5372 72.035 74.4513C72.1519 74.4008 72.2707 74.3546 72.3905 74.3104C72.7103 74.1921 73.0384 74.0942 73.3714 74.0215L104.329 67.8042ZM73.5474 76.644C73.3399 76.6442 73.1295 76.6722 72.9203 76.7303C71.5808 77.1026 70.7969 78.5735 71.1683 80.0142C71.4826 81.23 72.52 82.0357 73.6414 82.0342C73.8492 82.034 74.0599 82.007 74.2694 81.9488C75.609 81.5763 76.3934 80.1067 76.0213 78.6658C75.7067 77.4502 74.6689 76.6425 73.5474 76.644Z"
        fill="white"
      />
      <path
        d="M31.7003 48.2147C32.5384 47.1528 34.0713 47.1136 35.007 48.0839L38.1901 51.3849C39.1658 52.397 39.068 54.0615 38.0513 55.0293C31.4545 61.309 27.1354 70.1221 26.5299 79.9826C26.4489 81.3026 25.4227 82.3769 24.1474 82.3769H22.2601C20.9848 82.3769 19.9455 81.3031 20.0012 79.9817C20.5077 67.9514 24.8125 56.9441 31.7003 48.2147Z"
        fill="white"
      />
      <path
        d="M107.486 46.2655C108.394 45.3244 109.872 45.3284 110.729 46.3185C118.529 55.3238 123.453 67.0628 123.997 79.9817C124.052 81.303 123.013 82.3769 121.738 82.3769H100.332C99.0568 82.3767 98.0306 81.3024 97.9495 79.9826C97.9294 79.6552 97.9042 79.3291 97.8759 79.0041L106.642 75.8656C109.346 74.8973 110.785 71.9793 110.077 69.238C109.363 66.4766 106.666 64.6585 103.822 65.2295L94.8281 67.0351C94.3362 65.9124 93.7942 64.8184 93.2006 63.7589C92.6517 62.7791 92.7692 61.5293 93.5417 60.728L107.486 46.2655Z"
        fill="white"
      />
      <path
        d="M74.3083 28.4466C85.9069 28.972 96.5189 33.4363 104.935 40.5797C105.959 41.4489 105.997 43.0391 105.061 44.0096L92.1198 57.4322C91.144 58.4443 89.5389 58.3441 88.6058 57.2895C84.57 52.7285 79.45 49.2161 73.6676 47.1961C72.6885 46.854 71.9994 45.9204 71.9994 44.8488V30.7887C71.9996 29.4662 73.0343 28.3888 74.3083 28.4466Z"
        fill="white"
      />
      <path
        d="M66.2993 28.7174C67.6225 28.568 68.746 29.668 68.7461 31.0485V43.0013C68.7461 44.4973 67.4375 45.6224 66.003 45.4666C64.7664 45.3323 63.511 45.2632 62.2401 45.2632C55.6981 45.2632 49.5655 47.084 44.289 50.2638C43.3442 50.833 42.14 50.7104 41.3674 49.9091L37.1821 45.5691C36.2747 44.6279 36.2783 43.0953 37.2329 42.2058C45.1208 34.8575 55.1841 29.973 66.2993 28.7174Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_2107_36727"
          x="-8.44542"
          y="-0.000108719"
          width="160.889"
          height="112.889"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14.2222"
            result="effect1_foregroundBlur_2107_36727"
          />
        </filter>
        <filter
          id="filter1_f_2107_36727"
          x="7.55458"
          y="15.9999"
          width="128.889"
          height="80.8889"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.22222"
            result="effect1_foregroundBlur_2107_36727"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2107_36727"
          x1="123.999"
          y1="28.4443"
          x2="77.2467"
          y2="115.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
      </defs>
    </symbol>

    <symbol
      id="settings"
      viewBox="0 0 130 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" filter="url(#filter0_f_2107_36726)">
        <path
          d="M71.8264 58.8656C73.1497 57.5552 75.3137 57.537 76.6601 58.825C78.0065 60.1129 78.0251 62.2192 76.7019 63.5297L65.5381 74.5865C63.8936 76.2148 61.2077 76.2482 59.521 74.6612L53.942 69.4122C52.5847 68.1351 52.5481 66.0286 53.8602 64.7075C55.1724 63.3864 57.3366 63.3508 58.6939 64.6279L62.4444 68.1565L71.8264 58.8656Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.3711 33.2817C72.3711 34.7963 73.4424 36.095 74.9154 36.5618C79.3173 37.9567 83.3082 40.242 86.6663 43.2C87.8144 44.2113 89.4958 44.4673 90.8343 43.7125L93.6643 42.1166C95.2601 41.2166 97.2996 41.7512 98.2216 43.311L102.401 50.3821C103.325 51.9447 102.777 53.9439 101.178 54.8454L98.3674 56.4304C97.0265 57.1866 96.4112 58.742 96.7328 60.2229C97.1971 62.3606 97.4423 64.5773 97.4423 66.8501C97.4423 69.1227 97.197 71.3392 96.7327 73.4768C96.4111 74.9575 97.0264 76.5128 98.3671 77.269L101.179 78.8547C102.777 79.7563 103.325 81.7554 102.401 83.3179L98.2217 90.389C97.2997 91.9489 95.2601 92.4834 93.6642 91.5833L90.8344 89.9872C89.4959 89.2322 87.8143 89.4882 86.6661 90.4996C83.308 93.4576 79.3173 95.7427 74.9154 97.1376C73.4424 97.6044 72.3711 98.9031 72.3711 100.418V103.585C72.3711 105.388 70.8765 106.85 69.0329 106.85H60.6665C58.8229 106.85 57.3283 105.388 57.3283 103.585V100.418C57.3283 98.9031 56.257 97.6044 54.784 97.1377C50.382 95.7429 46.3908 93.4582 43.0325 90.5004C41.8842 89.4891 40.2027 89.2331 38.8641 89.9881L36.036 91.5832C34.4402 92.4834 32.4005 91.9489 31.4785 90.3889L27.2989 83.3179C26.3753 81.7553 26.9229 79.7563 28.5214 78.8547L31.3315 77.2698C32.6722 76.5136 33.2875 74.9583 32.966 73.4775C32.5019 71.3397 32.2571 69.1229 32.2571 66.8501C32.2571 64.5771 32.5018 62.3601 32.9659 60.2221C33.2874 58.7412 32.672 57.1858 31.3311 56.4296L28.5217 54.8454C26.9231 53.9439 26.3754 51.9447 27.299 50.3821L31.4786 43.3111C32.4006 41.7512 34.4401 41.2167 36.0359 42.1166L38.8643 43.7116C40.2028 44.4665 41.8842 44.2105 43.0323 43.1992C46.3906 40.2414 50.3819 37.9566 54.784 36.5617C56.257 36.095 57.3283 34.7963 57.3283 33.2817V30.1154C57.3283 28.312 58.8229 26.8501 60.6665 26.8501H69.0329C70.8765 26.8501 72.3711 28.312 72.3711 30.1154V33.2817ZM64.8497 44.8093C52.3879 44.8093 42.2856 54.6773 42.2856 66.8501C42.2856 79.0229 52.3879 88.8909 64.8497 88.8909C77.3115 88.8909 87.4138 79.0229 87.4138 66.8501C87.4138 54.6773 77.3115 44.8093 64.8497 44.8093Z"
          fill="url(#paint0_linear_2107_36726)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_f_2107_36726)">
        <path
          d="M72.2186 58.8907C73.5419 57.5803 75.7059 57.5622 77.0523 58.8501C78.3987 60.1381 78.4173 62.2443 77.0941 63.5548L65.9303 74.6116C64.2858 76.24 61.5999 76.2733 59.9132 74.6864L54.3342 69.4374C52.9769 68.1603 52.9403 66.0538 54.2524 64.7327C55.5646 63.4116 57.7288 63.376 59.0862 64.653L62.8366 68.1816L72.2186 58.8907Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M72.3711 33.2817C72.3711 34.7963 73.4424 36.095 74.9154 36.5618C79.3173 37.9567 83.3082 40.242 86.6663 43.2C87.8144 44.2113 89.4958 44.4673 90.8343 43.7125L93.6643 42.1166C95.2601 41.2166 97.2996 41.7512 98.2216 43.311L102.401 50.3821C103.325 51.9447 102.777 53.9439 101.178 54.8454L98.3674 56.4304C97.0265 57.1866 96.4112 58.742 96.7328 60.2229C97.1971 62.3606 97.4423 64.5773 97.4423 66.8501C97.4423 69.1227 97.197 71.3392 96.7327 73.4768C96.4111 74.9575 97.0264 76.5128 98.3671 77.269L101.179 78.8547C102.777 79.7563 103.325 81.7554 102.401 83.3179L98.2217 90.389C97.2997 91.9489 95.2601 92.4834 93.6642 91.5833L90.8344 89.9872C89.4959 89.2322 87.8143 89.4882 86.6661 90.4996C83.308 93.4576 79.3173 95.7427 74.9154 97.1376C73.4424 97.6044 72.3711 98.9031 72.3711 100.418V103.585C72.3711 105.388 70.8765 106.85 69.0329 106.85H60.6665C58.8229 106.85 57.3283 105.388 57.3283 103.585V100.418C57.3283 98.9031 56.257 97.6044 54.784 97.1377C50.382 95.7429 46.3908 93.4582 43.0325 90.5004C41.8842 89.4891 40.2027 89.2331 38.8641 89.9881L36.036 91.5832C34.4402 92.4834 32.4005 91.9489 31.4785 90.3889L27.2989 83.3179C26.3753 81.7553 26.9229 79.7563 28.5214 78.8547L31.3315 77.2698C32.6722 76.5136 33.2875 74.9583 32.966 73.4775C32.5019 71.3397 32.2571 69.1229 32.2571 66.8501C32.2571 64.5771 32.5018 62.3601 32.9659 60.2221C33.2874 58.7412 32.672 57.1858 31.3311 56.4296L28.5217 54.8454C26.9231 53.9439 26.3754 51.9447 27.299 50.3821L31.4786 43.3111C32.4006 41.7512 34.4401 41.2167 36.0359 42.1166L38.8643 43.7116C40.2028 44.4665 41.8842 44.2105 43.0323 43.1992C46.3906 40.2414 50.3819 37.9566 54.784 36.5617C56.257 36.095 57.3283 34.7963 57.3283 33.2817V30.1154C57.3283 28.312 58.8229 26.8501 60.6665 26.8501H69.0329C70.8765 26.8501 72.3711 28.312 72.3711 30.1154V33.2817ZM64.8497 43.2C51.7524 43.2 40.7524 53.8501 40.7524 67.2609C40.7524 79.4337 51.2524 90.5004 64.8497 90.5004C77.3115 90.5004 88.7524 80.8501 88.7524 66.8501C88.7524 53.8501 78.2524 43.2 64.8497 43.2Z"
          fill="url(#paint1_linear_2107_36726)"
        />
      </g>
      <path
        d="M72.2109 58.8656C73.5342 57.5552 75.6982 57.537 77.0446 58.825C78.391 60.1129 78.4096 62.2192 77.0864 63.5297L65.9226 74.5865C64.2781 76.2148 61.5922 76.2482 59.9055 74.6612L54.3266 69.4122C52.9693 68.1351 52.9327 66.0286 54.2448 64.7075C55.5569 63.3864 57.7211 63.3508 59.0785 64.6279L62.8289 68.1565L72.2109 58.8656Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M69.033 26.8501C70.8766 26.8501 72.3712 28.312 72.3712 30.1154V33.2819C72.3712 34.7964 73.4426 36.0947 74.9156 36.5615C79.3174 37.9565 83.3082 40.2419 86.6663 43.1997C87.8144 44.211 89.4962 44.4672 90.8347 43.7123L93.6647 42.1164C95.2604 41.2167 97.2999 41.7516 98.2218 43.3114L102.401 50.3825C103.325 51.945 102.777 53.9437 101.178 54.8452L98.3671 56.4308C97.0265 57.187 96.411 58.7423 96.7326 60.223C97.1969 62.3607 97.4426 64.5774 97.4426 66.8501C97.4426 69.1227 97.1969 71.3396 96.7326 73.4772C96.4112 74.9578 97.0266 76.5125 98.3671 77.2686L101.178 78.855C102.777 79.7565 103.325 81.7552 102.401 83.3177L98.2218 90.3888C97.2998 91.9488 95.2597 92.4831 93.6639 91.583L90.8347 89.9871C89.4962 89.2321 87.8145 89.4883 86.6663 90.4996C83.3082 93.4576 79.3174 95.743 74.9156 97.1379C73.4426 97.6047 72.3712 98.903 72.3712 100.418V103.585C72.3712 105.388 70.8766 106.85 69.033 106.85H60.6664C58.8229 106.85 57.3282 105.388 57.3282 103.585V100.418C57.3281 98.903 56.2568 97.6046 54.7838 97.1379C50.3818 95.7431 46.3904 93.4582 43.0322 90.5005C41.884 89.4892 40.2024 89.2329 38.8639 89.9879L36.0363 91.583C34.4405 92.4832 32.4004 91.9488 31.4783 90.3888L27.2987 83.3177C26.3753 81.7552 26.9233 79.7565 28.5217 78.855L31.3315 77.2694C32.6721 76.5132 33.2874 74.9579 32.9659 73.4772C32.5019 71.3395 32.2568 69.1228 32.2568 66.8501C32.2568 64.5772 32.5019 62.3601 32.9659 60.2222C33.2874 58.7414 32.6721 57.1862 31.3315 56.43L28.5217 54.8452C26.9232 53.9436 26.376 51.945 27.2995 50.3825L31.4783 43.3114C32.4003 41.7515 34.4405 41.2164 36.0363 42.1164L38.8647 43.7115C40.2031 44.4662 41.8841 44.2101 43.0322 43.1989C46.3905 40.2412 50.3818 37.9563 54.7838 36.5615C56.2568 36.0948 57.3281 34.7964 57.3282 33.2819V30.1154C57.3282 28.3121 58.8229 26.8502 60.6664 26.8501H69.033ZM64.8501 43.1766C51.6193 43.1767 40.8936 53.7756 40.8936 66.8501C40.8936 79.9246 51.6193 90.5235 64.8501 90.5236C78.0809 90.5236 88.8066 79.9246 88.8066 66.8501C88.8066 53.7756 78.0809 43.1766 64.8501 43.1766Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_2107_36726"
          x="-0.000213623"
          y="-0.000213623"
          width="129.701"
          height="133.701"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="13.4252"
            result="effect1_foregroundBlur_2107_36726"
          />
        </filter>
        <filter
          id="filter1_f_2107_36726"
          x="13.4249"
          y="13.4249"
          width="102.85"
          height="106.85"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="6.71258"
            result="effect1_foregroundBlur_2107_36726"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2107_36726"
          x1="102.85"
          y1="26.8501"
          x2="22.9552"
          y2="102.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2107_36726"
          x1="102.85"
          y1="26.8501"
          x2="22.9552"
          y2="102.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
      </defs>
    </symbol>

    <symbol
      id="provider"
      viewBox="0 0 125 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" filter="url(#filter0_f_2107_36730)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.9572 28.4443C94.8831 28.4443 96.4443 30.0056 96.4443 31.9315V45.8802C96.4443 47.8061 94.8831 49.3674 92.9572 49.3674H31.9315C30.0056 49.3674 28.4443 47.8061 28.4443 45.8802V31.9315C28.4443 30.0056 30.0056 28.4443 31.9315 28.4443H92.9572ZM37.1623 35.4187C36.1993 35.4187 35.4187 36.1993 35.4187 37.1623V40.6495C35.4187 41.6124 36.1993 42.3931 37.1623 42.3931H77.2649C78.2278 42.3931 79.0084 41.6124 79.0084 40.6495V37.1623C79.0084 36.1993 78.2278 35.4187 77.2649 35.4187H37.1623ZM84.2392 35.4187C83.2762 35.4187 82.4956 36.1993 82.4956 37.1623V40.6495C82.4956 41.6124 83.2762 42.3931 84.2392 42.3931H87.7264C88.6893 42.3931 89.47 41.6124 89.47 40.6495V37.1623C89.47 36.1993 88.6893 35.4187 87.7264 35.4187H84.2392Z"
          fill="url(#paint0_linear_2107_36730)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.9572 51.9828C94.8831 51.9828 96.4443 53.5441 96.4443 55.47V69.4187C96.4443 71.3446 94.8831 72.9059 92.9572 72.9059H31.9315C30.0056 72.9059 28.4443 71.3446 28.4443 69.4187V55.47C28.4443 53.5441 30.0056 51.9828 31.9315 51.9828H92.9572ZM37.1623 58.9572C36.1993 58.9572 35.4187 59.7378 35.4187 60.7007V64.1879C35.4187 65.1509 36.1993 65.9315 37.1623 65.9315H77.2649C78.2278 65.9315 79.0084 65.1509 79.0084 64.1879V60.7007C79.0084 59.7378 78.2278 58.9572 77.2649 58.9572H37.1623ZM84.2392 58.9572C83.2762 58.9572 82.4956 59.7378 82.4956 60.7007V64.1879C82.4956 65.1509 83.2762 65.9315 84.2392 65.9315H87.7264C88.6893 65.9315 89.47 65.1509 89.47 64.1879V60.7007C89.47 59.7378 88.6893 58.9572 87.7264 58.9572H84.2392Z"
          fill="url(#paint1_linear_2107_36730)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.9572 75.5213C94.8831 75.5213 96.4443 77.0825 96.4443 79.0084V92.9572C96.4443 94.8831 94.8831 96.4443 92.9572 96.4443H31.9315C30.0056 96.4443 28.4443 94.8831 28.4443 92.9572V79.0084C28.4443 77.0825 30.0056 75.5213 31.9315 75.5213H92.9572ZM37.1623 82.4956C36.1993 82.4956 35.4187 83.2762 35.4187 84.2392V87.7264C35.4187 88.6893 36.1993 89.47 37.1623 89.47H77.2649C78.2278 89.47 79.0084 88.6893 79.0084 87.7264V84.2392C79.0084 83.2762 78.2278 82.4956 77.2649 82.4956H37.1623ZM84.2392 82.4956C83.2762 82.4956 82.4956 83.2762 82.4956 84.2392V87.7264C82.4956 88.6893 83.2762 89.47 84.2392 89.47H87.7264C88.6893 89.47 89.47 88.6893 89.47 87.7264V84.2392C89.47 83.2762 88.6893 82.4956 87.7264 82.4956H84.2392Z"
          fill="url(#paint2_linear_2107_36730)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_f_2107_36730)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.9572 28.4443C94.8831 28.4443 96.4443 30.0056 96.4443 31.9315V45.8802C96.4443 47.8061 94.8831 49.3674 92.9572 49.3674H31.9315C30.0056 49.3674 28.4443 47.8061 28.4443 45.8802V31.9315C28.4443 30.0056 30.0056 28.4443 31.9315 28.4443H92.9572ZM37.1623 35.4187C36.1993 35.4187 35.4187 36.1993 35.4187 37.1623V40.6495C35.4187 41.6124 36.1993 42.3931 37.1623 42.3931H77.2649C78.2278 42.3931 79.0084 41.6124 79.0084 40.6495V37.1623C79.0084 36.1993 78.2278 35.4187 77.2649 35.4187H37.1623ZM84.2392 35.4187C83.2762 35.4187 82.4956 36.1993 82.4956 37.1623V40.6495C82.4956 41.6124 83.2762 42.3931 84.2392 42.3931H87.7264C88.6893 42.3931 89.47 41.6124 89.47 40.6495V37.1623C89.47 36.1993 88.6893 35.4187 87.7264 35.4187H84.2392Z"
          fill="url(#paint3_linear_2107_36730)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.9572 51.9828C94.8831 51.9828 96.4443 53.5441 96.4443 55.47V69.4187C96.4443 71.3446 94.8831 72.9059 92.9572 72.9059H31.9315C30.0056 72.9059 28.4443 71.3446 28.4443 69.4187V55.47C28.4443 53.5441 30.0056 51.9828 31.9315 51.9828H92.9572ZM37.1623 58.9572C36.1993 58.9572 35.4187 59.7378 35.4187 60.7007V64.1879C35.4187 65.1509 36.1993 65.9315 37.1623 65.9315H77.2649C78.2278 65.9315 79.0084 65.1509 79.0084 64.1879V60.7007C79.0084 59.7378 78.2278 58.9572 77.2649 58.9572H37.1623ZM84.2392 58.9572C83.2762 58.9572 82.4956 59.7378 82.4956 60.7007V64.1879C82.4956 65.1509 83.2762 65.9315 84.2392 65.9315H87.7264C88.6893 65.9315 89.47 65.1509 89.47 64.1879V60.7007C89.47 59.7378 88.6893 58.9572 87.7264 58.9572H84.2392Z"
          fill="url(#paint4_linear_2107_36730)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.9572 75.5213C94.8831 75.5213 96.4443 77.0825 96.4443 79.0084V92.9572C96.4443 94.8831 94.8831 96.4443 92.9572 96.4443H31.9315C30.0056 96.4443 28.4443 94.8831 28.4443 92.9572V79.0084C28.4443 77.0825 30.0056 75.5213 31.9315 75.5213H92.9572ZM37.1623 82.4956C36.1993 82.4956 35.4187 83.2762 35.4187 84.2392V87.7264C35.4187 88.6893 36.1993 89.47 37.1623 89.47H77.2649C78.2278 89.47 79.0084 88.6893 79.0084 87.7264V84.2392C79.0084 83.2762 78.2278 82.4956 77.2649 82.4956H37.1623ZM84.2392 82.4956C83.2762 82.4956 82.4956 83.2762 82.4956 84.2392V87.7264C82.4956 88.6893 83.2762 89.47 84.2392 89.47H87.7264C88.6893 89.47 89.47 88.6893 89.47 87.7264V84.2392C89.47 83.2762 88.6893 82.4956 87.7264 82.4956H84.2392Z"
          fill="url(#paint5_linear_2107_36730)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M91.2139 28.4443C94.1026 28.4443 96.4442 30.7861 96.4443 33.6748V44.1367C96.4443 47.0256 94.1027 49.3672 91.2139 49.3672H33.6748C30.7861 49.367 28.4443 47.0255 28.4443 44.1367V33.6748C28.4445 30.7862 30.7862 28.4445 33.6748 28.4443H91.2139ZM37.1631 35.4189C36.2002 35.4189 35.4191 36.1993 35.4189 37.1621V40.6494C35.4189 41.6124 36.2001 42.3935 37.1631 42.3935H77.2656C78.2285 42.3934 79.0088 41.6123 79.0088 40.6494V37.1621C79.0087 36.1993 78.2284 35.4191 77.2656 35.4189H37.1631ZM84.2402 35.4189C83.2773 35.4189 82.4962 36.1993 82.4961 37.1621V40.6494C82.4961 41.6124 83.2773 42.3935 84.2402 42.3935H87.7266C88.6895 42.3935 89.4707 41.6124 89.4707 40.6494V37.1621C89.4706 36.1993 88.6894 35.4189 87.7266 35.4189H84.2402Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M91.2139 51.9829C94.1026 51.9829 96.4442 54.3246 96.4443 57.2134V67.6753C96.4443 70.5642 94.1027 72.9058 91.2139 72.9058H33.6748C30.7861 72.9056 28.4443 70.5641 28.4443 67.6753V57.2134C28.4445 54.3247 30.7862 51.9831 33.6748 51.9829H91.2139ZM37.1631 58.9575C36.2002 58.9575 35.4191 59.7378 35.4189 60.7007V64.188C35.4189 65.1509 36.2001 65.9321 37.1631 65.9321H77.2656C78.2285 65.932 79.0088 65.1509 79.0088 64.188V60.7007C79.0087 59.7379 78.2284 58.9576 77.2656 58.9575H37.1631ZM84.2402 58.9575C83.2773 58.9575 82.4962 59.7378 82.4961 60.7007V64.188C82.4961 65.1509 83.2773 65.9321 84.2402 65.9321H87.7266C88.6895 65.9321 89.4707 65.1509 89.4707 64.188V60.7007C89.4706 59.7378 88.6894 58.9575 87.7266 58.9575H84.2402Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M91.2139 75.5215C94.1026 75.5215 96.4442 77.8632 96.4443 80.752V91.2139C96.4443 94.1027 94.1027 96.4443 91.2139 96.4443H33.6748C30.7861 96.4442 28.4443 94.1026 28.4443 91.2139V80.752C28.4445 77.8633 30.7862 75.5217 33.6748 75.5215H91.2139ZM37.1631 82.4961C36.2002 82.4961 35.4191 83.2764 35.4189 84.2393V87.7266C35.4189 88.6895 36.2001 89.4707 37.1631 89.4707H77.2656C78.2285 89.4706 79.0088 88.6894 79.0088 87.7266V84.2393C79.0087 83.2765 78.2284 82.4962 77.2656 82.4961H37.1631ZM84.2402 82.4961C83.2773 82.4961 82.4962 83.2764 82.4961 84.2393V87.7266C82.4961 88.6895 83.2773 89.4707 84.2402 89.4707H87.7266C88.6895 89.4707 89.4707 88.6895 89.4707 87.7266V84.2393C89.4706 83.2764 88.6894 82.4961 87.7266 82.4961H84.2402Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_2107_36730"
          x="-0.000108719"
          y="-0.000108719"
          width="124.889"
          height="124.889"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14.2222"
            result="effect1_foregroundBlur_2107_36730"
          />
        </filter>
        <filter
          id="filter1_f_2107_36730"
          x="14.2221"
          y="14.2221"
          width="96.4444"
          height="96.4444"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="7.11111"
            result="effect1_foregroundBlur_2107_36730"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2107_36730"
          x1="96.4443"
          y1="28.4443"
          x2="28.4443"
          y2="96.4443"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2107_36730"
          x1="96.4443"
          y1="28.4443"
          x2="28.4443"
          y2="96.4443"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2107_36730"
          x1="96.4443"
          y1="28.4443"
          x2="28.4443"
          y2="96.4443"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2107_36730"
          x1="96.4443"
          y1="28.4443"
          x2="28.4443"
          y2="96.4443"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2107_36730"
          x1="96.4443"
          y1="28.4443"
          x2="28.4443"
          y2="96.4443"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2107_36730"
          x1="96.4443"
          y1="28.4443"
          x2="28.4443"
          y2="96.4443"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
      </defs>
    </symbol>

    <symbol
      id="ios"
      viewBox="0 0 113 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" filter="url(#filter0_f_2107_36729)">
        <path
          d="M70.0487 42.0589C78.203 42.6739 75.6779 53.1638 75.238 61.3295C75.2203 61.6576 75.2126 61.9925 75.2158 62.3343C75.2381 64.9569 75.8086 67.1465 76.6559 68.9573C79.2903 74.5872 83.153 81.2946 79.6821 86.4511C76.8147 90.7213 73.8445 94.9674 69.1565 95.056C64.5508 95.1419 63.0664 92.2746 57.8049 92.2746C52.5402 92.2746 50.8924 94.9673 46.5369 95.1419C42.0121 95.3161 38.5671 90.5306 35.6786 86.2838C29.7738 77.5928 25.259 61.7224 31.3213 51.0122C34.3309 45.6931 39.7102 42.3233 45.547 42.2362C49.9921 42.1507 54.1842 45.2778 56.9031 45.2778C59.5833 45.2778 64.3867 41.6325 70.0487 42.0589ZM66.555 36.3216C66.6197 36.2421 66.6837 36.1618 66.7472 36.0806C70.8138 30.8806 64.2481 25.3938 60.003 30.4491C55.5734 35.6673 62.2413 41.6359 66.555 36.3216Z"
          fill="url(#paint0_linear_2107_36729)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_f_2107_36729)">
        <path
          d="M70.0487 42.0589C78.203 42.6739 75.6779 53.1638 75.238 61.3295C75.2203 61.6576 75.2126 61.9925 75.2158 62.3343C75.2381 64.9569 75.8086 67.1465 76.6559 68.9573C79.2903 74.5872 83.153 81.2946 79.6821 86.4511C76.8147 90.7213 73.8445 94.9674 69.1565 95.056C64.5508 95.1419 63.0664 92.2746 57.8049 92.2746C52.5402 92.2746 50.8924 94.9673 46.5369 95.1419C42.0121 95.3161 38.5671 90.5306 35.6786 86.2838C29.7738 77.5928 25.259 61.7224 31.3213 51.0122C34.3309 45.6931 39.7102 42.3233 45.547 42.2362C49.9921 42.1507 54.1842 45.2778 56.9031 45.2778C59.5833 45.2778 64.3867 41.6325 70.0487 42.0589ZM66.555 36.3216C66.6197 36.2421 66.6837 36.1618 66.7472 36.0806C70.8138 30.8806 64.2481 25.3938 60.003 30.4491C55.5734 35.6673 62.2413 41.6359 66.555 36.3216Z"
          fill="url(#paint1_linear_2107_36729)"
        />
      </g>
      <path
        d="M82.6456 49.0141C82.319 49.2191 75.1342 53.4767 75.2158 62.3343C75.3061 72.9289 84.3406 76.4569 84.4443 76.497C84.3634 76.7492 82.9999 81.522 79.6821 86.4511C76.8147 90.7213 73.8445 94.9674 69.1565 95.056C64.5508 95.1419 63.0664 92.2746 57.8049 92.2746C52.5402 92.2746 50.8924 94.9673 46.5369 95.1419C42.0121 95.3161 38.5671 90.5306 35.6786 86.2838C29.7738 77.5928 25.259 61.7224 31.3213 51.0122C34.3309 45.6931 39.7102 42.3233 45.547 42.2362C49.9921 42.1507 54.1842 45.2778 56.9031 45.2778C59.5833 45.2778 64.3867 41.6325 70.0487 42.0589C72.2678 42.2262 78.5672 42.9004 82.6456 49.0141ZM66.555 36.3216C68.9597 33.3636 70.5776 29.244 70.1321 25.1465C66.6712 25.2862 62.4853 27.493 60.003 30.4491C57.78 33.0678 55.8277 37.262 56.3577 41.2758C60.2153 41.5792 64.1524 39.2815 66.555 36.3216Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_2107_36729"
          x="-0.000108719"
          y="-0.000108719"
          width="109.506"
          height="123.591"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14.2222"
            result="effect1_foregroundBlur_2107_36729"
          />
        </filter>
        <filter
          id="filter1_f_2107_36729"
          x="14.2221"
          y="14.2221"
          width="81.0611"
          height="95.1466"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="7.11111"
            result="effect1_foregroundBlur_2107_36729"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2107_36729"
          x1="84.4443"
          y1="25.1465"
          x2="16.1517"
          y2="79.7806"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2107_36729"
          x1="84.4443"
          y1="25.1465"
          x2="16.1517"
          y2="79.7806"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
      </defs>
    </symbol>

    <symbol
      id="dark-mode"
      viewBox="0 0 147 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" filter="url(#filter0_f_2107_36728)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.3443 30C106.759 30 118.444 41.6406 118.444 56C118.444 70.3594 106.759 82 92.3443 82H54.5443C40.1297 82 28.4443 70.3594 28.4443 56C28.4443 41.6406 40.1297 30 54.5443 30H92.3443ZM92.3443 33.5862C79.9179 33.5862 69.8443 43.6212 69.8443 56C69.8443 68.3788 79.9179 78.4138 92.3443 78.4138C104.771 78.4138 114.844 68.3788 114.844 56C114.844 43.6212 104.771 33.5862 92.3443 33.5862Z"
          fill="url(#paint0_linear_2107_36728)"
        />
        <path
          d="M85.4953 39.6165C86.1797 39.3132 86.8535 39.9926 86.6678 40.7155C86.303 42.1354 86.1083 43.6262 86.1083 45.1636C86.1083 54.784 93.7083 62.5829 103.083 62.5829H104.441C105.543 62.5829 106.619 62.4748 107.662 62.2688C108.397 62.1237 109.049 62.8276 108.717 63.4968C105.914 69.1564 100.188 73.0345 93.5773 73.0345H92.2193C82.8443 73.0345 75.2443 65.2356 75.2443 55.6152C75.2443 48.4461 79.4649 42.2889 85.4953 39.6165Z"
          fill="url(#paint1_linear_2107_36728)"
        />
      </g>
      <g opacity="0.5" filter="url(#filter1_f_2107_36728)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M92.3443 30C106.759 30 118.444 41.6406 118.444 56C118.444 70.3594 106.759 82 92.3443 82H54.5443C40.1297 82 28.4443 70.3594 28.4443 56C28.4443 41.6406 40.1297 30 54.5443 30H92.3443ZM92.3443 33.5862C79.9179 33.5862 69.8443 43.6212 69.8443 56C69.8443 68.3788 79.9179 78.4138 92.3443 78.4138C104.771 78.4138 114.844 68.3788 114.844 56C114.844 43.6212 104.771 33.5862 92.3443 33.5862Z"
          fill="url(#paint2_linear_2107_36728)"
        />
        <path
          d="M85.4953 39.6165C86.1797 39.3132 86.8535 39.9926 86.6678 40.7155C86.303 42.1354 86.1083 43.6262 86.1083 45.1636C86.1083 54.784 93.7083 62.5829 103.083 62.5829H104.441C105.543 62.5829 106.619 62.4748 107.662 62.2688C108.397 62.1237 109.049 62.8276 108.717 63.4968C105.914 69.1564 100.188 73.0345 93.5773 73.0345H92.2193C82.8443 73.0345 75.2443 65.2356 75.2443 55.6152C75.2443 48.4461 79.4649 42.2889 85.4953 39.6165Z"
          fill="url(#paint3_linear_2107_36728)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M92.3443 30C106.759 30 118.444 41.6406 118.444 56C118.444 70.3594 106.759 82 92.3443 82H54.5443C40.1297 82 28.4443 70.3594 28.4443 56C28.4443 41.6406 40.1297 30 54.5443 30H92.3443ZM92.3443 33.5862C79.9179 33.5862 69.8443 43.6212 69.8443 56C69.8443 68.3788 79.9179 78.4138 92.3443 78.4138C104.771 78.4138 114.844 68.3788 114.844 56C114.844 43.6212 104.771 33.5862 92.3443 33.5862Z"
        fill="white"
      />
      <path
        d="M85.4953 39.6165C86.1797 39.3132 86.8535 39.9926 86.6678 40.7155C86.303 42.1354 86.1083 43.6262 86.1083 45.1636C86.1083 54.784 93.7083 62.5829 103.083 62.5829H104.441C105.543 62.5829 106.619 62.4748 107.662 62.2688C108.397 62.1237 109.049 62.8276 108.717 63.4968C105.914 69.1564 100.188 73.0345 93.5773 73.0345H92.2193C82.8443 73.0345 75.2443 65.2356 75.2443 55.6152C75.2443 48.4461 79.4649 42.2889 85.4953 39.6165Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_2107_36728"
          x="-0.000108719"
          y="1.55556"
          width="146.889"
          height="108.889"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="14.2222"
            result="effect1_foregroundBlur_2107_36728"
          />
        </filter>
        <filter
          id="filter1_f_2107_36728"
          x="14.2221"
          y="15.7778"
          width="118.444"
          height="80.4444"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="7.11111"
            result="effect1_foregroundBlur_2107_36728"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2107_36728"
          x1="118.444"
          y1="30"
          x2="73.3944"
          y2="107.971"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2107_36728"
          x1="118.444"
          y1="30"
          x2="73.3944"
          y2="107.971"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2107_36728"
          x1="118.444"
          y1="30"
          x2="73.3944"
          y2="107.971"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2107_36728"
          x1="118.444"
          y1="30"
          x2="73.3944"
          y2="107.971"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
      </defs>
    </symbol>

    <symbol
      id="logo-dark"
      viewBox="0 0 110 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.025 3.47339C29.1778 3.47339 32.5443 6.80381 32.5443 10.9121C32.5443 15.0204 29.1778 18.3508 25.025 18.3508C24.2136 18.3508 23.4323 18.2236 22.7002 17.9883C22.1688 17.8175 21.5473 18.263 21.5473 18.8157C21.5473 19.4012 22.1868 19.8828 22.7577 19.7286C23.3902 19.5578 24.0558 19.4666 24.743 19.4666C28.8958 19.4666 32.2623 22.7971 32.2623 26.9053C32.2623 31.0136 28.8958 34.3441 24.743 34.3441C24.2462 34.3441 23.7605 34.2963 23.2906 34.2053C22.752 34.1009 22.2053 34.545 22.2053 35.0879C22.2053 39.1962 18.8388 42.5266 14.686 42.5266C10.5332 42.5266 7.16675 39.1962 7.16673 35.0879C7.16673 30.9796 10.5332 27.6492 14.686 27.6492C15.1829 27.6492 15.6686 27.6969 16.1385 27.7879C16.677 27.8922 17.2238 27.4482 17.2238 26.9053C17.2238 26.3198 16.5841 25.8382 16.0131 25.9924C15.3808 26.1632 14.7152 26.2545 14.0281 26.2545C9.8753 26.2545 6.50881 22.924 6.50879 18.8157C6.50879 14.7074 9.87528 11.377 14.0281 11.377C14.8395 11.377 15.6208 11.5042 16.3529 11.7395C16.8843 11.9102 17.5057 11.4648 17.5057 10.9121C17.5057 6.80381 20.8722 3.47339 25.025 3.47339Z"
        fill="url(#paint0_linear_2128_1412)"
      />
      <path
        d="M47.8511 26.0104C48.1448 26.0155 48.381 26.2417 48.4379 26.5251C48.5983 27.3238 48.9981 27.9721 49.6229 28.4842C50.3747 29.1004 51.3771 29.3962 52.605 29.3962C53.6575 29.3962 54.5345 29.1743 55.1861 28.7307C55.8376 28.287 56.1885 27.6461 56.1885 26.8328C56.1885 26.2659 55.988 25.8222 55.6371 25.4771C55.2863 25.1321 54.7851 24.8856 54.1837 24.6884C53.5572 24.5159 52.6801 24.3187 51.5775 24.1215C50.4248 23.9243 49.4475 23.6778 48.6456 23.3574C47.8437 23.037 47.1671 22.544 46.6659 21.8785C46.1647 21.2377 45.9141 20.375 45.9141 19.2905C45.9141 18.3046 46.1647 17.4419 46.6909 16.6532C47.2172 15.8891 47.9439 15.2975 48.8962 14.8539C49.8484 14.4349 50.926 14.213 52.1539 14.213C53.4069 14.213 54.5095 14.4595 55.5119 14.9032C56.4892 15.3715 57.266 16.0123 57.8424 16.8011C58.288 17.4585 58.5863 18.1804 58.7107 18.9796C58.7597 19.2945 58.4986 19.5616 58.1747 19.5616H56.4456C56.1565 19.5616 55.9192 19.346 55.8473 19.0707C55.6739 18.4068 55.3071 17.8556 54.7601 17.4173C54.0584 16.875 53.2064 16.6039 52.1539 16.6039C51.1265 16.6039 50.2995 16.8257 49.6981 17.2694C49.0966 17.713 48.7959 18.3046 48.7959 19.0933C48.7959 19.6602 48.9713 20.1039 49.3222 20.4243C49.673 20.7694 50.1742 21.0159 50.7756 21.1637C51.377 21.3363 52.2291 21.5088 53.3567 21.706C54.4844 21.9032 55.4617 22.1743 56.2887 22.4947C57.0906 22.8398 57.7672 23.3081 58.2935 23.949C58.7946 24.5898 59.0703 25.4525 59.0703 26.4877C59.0703 27.5229 58.7946 28.4349 58.2433 29.2236C57.692 30.037 56.9152 30.6778 55.9379 31.1215C54.9355 31.5652 53.8329 31.787 52.5799 31.787C51.1766 31.787 49.9737 31.5405 48.9212 31.0476C47.8687 30.5546 47.0418 29.8891 46.4403 29.0018C45.9411 28.2652 45.6491 27.4437 45.5642 26.5373C45.5352 26.2266 45.7983 25.9746 46.1155 25.9801L47.8511 26.0104Z"
        fill="url(#paint1_linear_2128_1412)"
      />
      <path
        d="M63.9627 30.9983C62.9604 30.456 62.2086 29.7166 61.6573 28.7307C61.106 27.7447 60.8554 26.6109 60.8554 25.3292C60.8554 24.0722 61.106 22.963 61.6573 21.9771C62.2086 20.9912 62.9604 20.2271 63.9627 19.6849C64.9651 19.1426 66.0928 18.8715 67.3959 18.8715C68.6739 18.8715 69.8016 19.1426 70.804 19.6849C71.8063 20.2271 72.5581 20.9912 73.1094 21.9771C73.6607 22.963 73.9364 24.0722 73.9364 25.3292C73.9364 26.6109 73.6607 27.7447 73.1094 28.7307C72.5581 29.7166 71.8063 30.456 70.804 30.9983C69.8016 31.5405 68.6739 31.787 67.3959 31.787C66.0928 31.787 64.9651 31.5405 63.9627 30.9983ZM70.1274 28.3609C70.829 27.5722 71.1799 26.5616 71.1799 25.3292C71.1799 24.0968 70.829 23.1109 70.1274 22.3222C69.4257 21.5335 68.5236 21.1391 67.3959 21.1391C66.2432 21.1391 65.341 21.5335 64.6644 22.3222C63.9627 23.1109 63.637 24.0968 63.637 25.3292C63.637 26.5616 63.9627 27.5722 64.6644 28.3609C65.341 29.1497 66.2432 29.5194 67.3959 29.5194C68.5236 29.5194 69.4257 29.1497 70.1274 28.3609Z"
        fill="url(#paint2_linear_2128_1412)"
      />
      <path
        d="M87.9999 14.3856C88.3132 14.3856 88.5672 14.6354 88.5672 14.9435V31.0812C88.5672 31.3893 88.3132 31.6391 87.9999 31.6391H86.4531C86.1398 31.6391 85.8858 31.3893 85.8858 31.0812V30.5945C85.8858 30.3247 85.517 30.199 85.323 30.3897C84.3658 31.3306 83.1536 31.787 81.7009 31.787C80.5231 31.787 79.4706 31.5405 78.5685 31.0229C77.6413 30.5053 76.9146 29.7659 76.4134 28.7799C75.8871 27.794 75.6365 26.6602 75.6365 25.3292C75.6365 24.0476 75.8871 22.9384 76.4134 21.9525C76.9396 20.9666 77.6663 20.2271 78.5935 19.6849C79.4957 19.1426 80.5482 18.8715 81.7009 18.8715C82.6281 18.8715 83.4551 19.044 84.1567 19.3891C84.588 19.6012 84.9625 19.8506 85.2918 20.1486C85.4924 20.3302 85.8608 20.2006 85.8608 19.9325V14.9435C85.8608 14.6354 86.1147 14.3856 86.428 14.3856H87.9999ZM84.8584 28.3856C85.535 27.6215 85.8858 26.6109 85.8858 25.3785C85.8858 24.1215 85.535 23.1109 84.8584 22.3222C84.1567 21.5335 83.2546 21.1391 82.152 21.1391C81.0243 21.1391 80.1222 21.5335 79.4455 22.3222C78.7439 23.1109 78.4181 24.0968 78.4181 25.3292C78.4181 26.5863 78.7439 27.5969 79.4455 28.3856C80.1222 29.1743 81.0243 29.544 82.152 29.544C83.2546 29.544 84.1567 29.1743 84.8584 28.3856Z"
        fill="url(#paint3_linear_2128_1412)"
      />
      <path
        d="M102.965 29.3222C103.255 29.3222 103.491 29.5539 103.491 29.8398V31.0812C103.491 31.3893 103.237 31.6391 102.924 31.6391H102.063C101.211 31.6391 100.609 31.4666 100.258 31.1215C100.08 30.958 99.9473 30.7614 99.8565 30.529C99.7557 30.2708 99.3169 30.1449 99.1239 30.346C98.1978 31.3111 96.9851 31.787 95.472 31.787C94.0186 31.787 92.8658 31.4666 92.0138 30.8011C91.1367 30.1602 90.7107 29.2483 90.7107 28.0898C90.7107 26.8081 91.1618 25.7976 92.1141 25.1074C93.0413 24.4173 94.3945 24.0476 96.1987 24.0476H99.4314V23.2835C99.4314 22.5933 99.1808 22.0264 98.6796 21.6321C98.1784 21.2377 97.4768 21.0159 96.5997 21.0159C95.7978 21.0159 95.1462 21.1884 94.6451 21.5335C94.2885 21.779 94.0333 22.0744 93.8797 22.4198C93.7698 22.6668 93.5437 22.8645 93.2695 22.8645H91.7122C91.377 22.8645 91.1112 22.5786 91.187 22.2575C91.4163 21.2864 91.9557 20.5062 92.7907 19.9313C93.793 19.2412 95.0961 18.8715 96.725 18.8715C98.429 18.8715 99.7572 19.2659 100.709 20.0546C101.637 20.8433 102.113 21.9771 102.113 23.456V28.4349C102.113 29.0264 102.388 29.3222 102.965 29.3222ZM99.4314 26.463C99.4314 26.218 99.2295 26.0194 98.9803 26.0194H96.0735C95.2214 26.0194 94.595 26.1919 94.1439 26.5123C93.6928 26.8328 93.4673 27.3011 93.4673 27.9173C93.4673 28.4595 93.6677 28.9032 94.0937 29.2236C94.5198 29.5687 95.0961 29.7166 95.8479 29.7166C96.9505 29.7166 97.8276 29.4208 98.4541 28.8292C99.0806 28.2377 99.4064 27.449 99.4314 26.463Z"
        fill="url(#paint4_linear_2128_1412)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2128_1412"
          x1="-48.9651"
          y1="2.8722"
          x2="-41.5272"
          y2="58.8871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#184128" />
          <stop offset="1" stop-color="#051313" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2128_1412"
          x1="-48.9651"
          y1="2.8722"
          x2="-41.5272"
          y2="58.8871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#184128" />
          <stop offset="1" stop-color="#051313" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2128_1412"
          x1="-48.9651"
          y1="2.8722"
          x2="-41.5272"
          y2="58.8871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#184128" />
          <stop offset="1" stop-color="#051313" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2128_1412"
          x1="-48.9651"
          y1="2.8722"
          x2="-41.5272"
          y2="58.8871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#184128" />
          <stop offset="1" stop-color="#051313" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2128_1412"
          x1="-48.9651"
          y1="2.8722"
          x2="-41.5272"
          y2="58.8871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#184128" />
          <stop offset="1" stop-color="#051313" />
        </linearGradient>
      </defs>
    </symbol>

    <symbol
      id="logo"
      viewBox="0 0 180 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.9502 6.04736C47.7456 6.04736 53.2544 11.4972 53.2544 18.2198C53.2544 24.9424 47.7456 30.3922 40.9502 30.3922C39.6224 30.3922 38.3439 30.1841 37.1459 29.799C36.2764 29.5195 35.2594 30.2485 35.2594 31.153C35.2594 32.1111 36.3058 32.8991 37.2401 32.6468C38.275 32.3673 39.3642 32.2181 40.4887 32.2181C47.2842 32.2181 52.793 37.6679 52.793 44.3906C52.793 51.1132 47.2842 56.563 40.4887 56.563C39.6757 56.563 38.881 56.4849 38.112 56.3359C37.2307 56.1652 36.3361 56.8918 36.3361 57.7802C36.336 64.5029 30.8272 69.9527 24.0318 69.9527C17.2363 69.9527 11.7275 64.5029 11.7275 57.7802C11.7275 51.0576 17.2363 45.6078 24.0318 45.6078C24.8449 45.6078 25.6396 45.6859 26.4086 45.8348C27.2898 46.0054 28.1845 45.2789 28.1845 44.3906C28.1845 43.4324 27.1378 42.6443 26.2035 42.8967C25.1687 43.1762 24.0795 43.3255 22.9552 43.3255C16.1597 43.3255 10.6509 37.8756 10.6509 31.153C10.6509 24.4304 16.1597 18.9806 22.9552 18.9806C24.2829 18.9806 25.5615 19.1887 26.7595 19.5737C27.629 19.8531 28.6459 19.1242 28.6459 18.2198C28.6459 11.4972 34.1547 6.04736 40.9502 6.04736Z"
        fill="url(#paint0_linear_2110_41942)"
      />
      <path
        d="M78.302 42.926C78.7826 42.9344 79.1691 43.3046 79.2622 43.7684C79.5246 45.0752 80.1788 46.1361 81.2012 46.9741C82.4314 47.9824 84.0717 48.4664 86.081 48.4664C87.8032 48.4664 89.2385 48.1034 90.3046 47.3774C91.3708 46.6514 91.9449 45.6028 91.9449 44.2718C91.9449 43.3441 91.6168 42.6181 91.0427 42.0535C90.4687 41.4888 89.6485 41.0855 88.6644 40.7628C87.6392 40.4805 86.204 40.1578 84.3997 39.8352C82.5134 39.5125 80.9142 39.1092 79.602 38.5849C78.2898 38.0605 77.1826 37.2539 76.3625 36.1649C75.5424 35.1162 75.1323 33.7046 75.1323 31.9299C75.1323 30.3166 75.5424 28.9049 76.4035 27.6143C77.2646 26.364 78.4538 25.396 80.012 24.67C81.5703 23.9843 83.3336 23.6213 85.3429 23.6213C87.3932 23.6213 89.1975 24.0247 90.8377 24.7507C92.437 25.517 93.7082 26.5656 94.6513 27.8563C95.3805 28.9321 95.8686 30.1133 96.0722 31.4212C96.1524 31.9365 95.725 32.3736 95.1951 32.3736H92.3656C91.8926 32.3736 91.5044 32.0207 91.3867 31.5702C91.1029 30.4838 90.5026 29.5819 89.6075 28.8646C88.4594 27.9773 87.0651 27.5336 85.3429 27.5336C83.6616 27.5336 82.3084 27.8966 81.3242 28.6226C80.3401 29.3486 79.848 30.3166 79.848 31.6073C79.848 32.5349 80.1351 33.2609 80.7091 33.7852C81.2832 34.3499 82.1034 34.7532 83.0875 34.9952C84.0717 35.2776 85.4659 35.5599 87.3112 35.8825C89.1565 36.2052 90.7557 36.6489 92.1089 37.1732C93.4211 37.7379 94.5283 38.5042 95.3894 39.5528C96.2095 40.6015 96.6606 42.0132 96.6606 43.7071C96.6606 45.4011 96.2095 46.8934 95.3074 48.1841C94.4053 49.5151 93.1341 50.5637 91.5348 51.2897C89.8946 52.0157 88.0903 52.3787 86.04 52.3787C83.7436 52.3787 81.7753 51.9754 80.053 51.1687C78.3308 50.3621 76.9776 49.2731 75.9934 47.8211C75.1765 46.6158 74.6986 45.2715 74.5598 43.7882C74.5122 43.2799 74.9428 42.8676 75.4618 42.8766L78.302 42.926Z"
        fill="url(#paint1_linear_2110_41942)"
      />
      <path
        d="M104.666 51.0881C103.026 50.2007 101.796 48.9908 100.894 47.3774C99.9917 45.7641 99.5817 43.9088 99.5817 41.8115C99.5817 39.7545 99.9917 37.9395 100.894 36.3262C101.796 34.7129 103.026 33.4626 104.666 32.5752C106.307 31.6879 108.152 31.2443 110.284 31.2443C112.376 31.2443 114.221 31.6879 115.861 32.5752C117.501 33.4626 118.732 34.7129 119.634 36.3262C120.536 37.9395 120.987 39.7545 120.987 41.8115C120.987 43.9088 120.536 45.7641 119.634 47.3774C118.732 48.9908 117.501 50.2007 115.861 51.0881C114.221 51.9754 112.376 52.3787 110.284 52.3787C108.152 52.3787 106.307 51.9754 104.666 51.0881ZM114.754 46.7724C115.902 45.4818 116.476 43.8281 116.476 41.8115C116.476 39.7948 115.902 38.1815 114.754 36.8909C113.606 35.6002 112.13 34.9549 110.284 34.9549C108.398 34.9549 106.922 35.6002 105.815 36.8909C104.666 38.1815 104.133 39.7948 104.133 41.8115C104.133 43.8281 104.666 45.4818 105.815 46.7724C106.922 48.0631 108.398 48.6681 110.284 48.6681C112.13 48.6681 113.606 48.0631 114.754 46.7724Z"
        fill="url(#paint2_linear_2110_41942)"
      />
      <path
        d="M144 23.9037C144.513 23.9037 144.928 24.3124 144.928 24.8166V51.2238C144.928 51.728 144.513 52.1367 144 52.1367H141.469C140.956 52.1367 140.541 51.728 140.541 51.2238V50.4273C140.541 49.986 139.937 49.7803 139.62 50.0922C138.053 51.6318 136.07 52.3787 133.693 52.3787C131.765 52.3787 130.043 51.9754 128.567 51.1284C127.049 50.2814 125.86 49.0714 125.04 47.4581C124.179 45.8448 123.769 43.9895 123.769 41.8115C123.769 39.7142 124.179 37.8992 125.04 36.2859C125.901 34.6726 127.09 33.4626 128.608 32.5752C130.084 31.6879 131.806 31.2443 133.693 31.2443C135.21 31.2443 136.563 31.5266 137.711 32.0912C138.417 32.4383 139.03 32.8464 139.569 33.3341C139.897 33.6312 140.5 33.4191 140.5 32.9805V24.8166C140.5 24.3124 140.915 23.9037 141.428 23.9037H144ZM138.859 46.8128C139.966 45.5625 140.541 43.9088 140.541 41.8922C140.541 39.8352 139.966 38.1815 138.859 36.8909C137.711 35.6002 136.235 34.9549 134.431 34.9549C132.585 34.9549 131.109 35.6002 130.002 36.8909C128.854 38.1815 128.321 39.7948 128.321 41.8115C128.321 43.8685 128.854 45.5221 130.002 46.8128C131.109 48.1034 132.585 48.7084 134.431 48.7084C136.235 48.7084 137.711 48.1034 138.859 46.8128Z"
        fill="url(#paint3_linear_2110_41942)"
      />
      <path
        d="M168.488 48.3454C168.964 48.3454 169.349 48.7246 169.349 49.1924V51.2238C169.349 51.728 168.934 52.1367 168.421 52.1367H167.012C165.618 52.1367 164.633 51.8544 164.059 51.2897C163.768 51.0223 163.55 50.7005 163.402 50.3202C163.237 49.8977 162.519 49.6917 162.203 50.0208C160.687 51.6001 158.703 52.3787 156.227 52.3787C153.849 52.3787 151.962 51.8544 150.568 50.7654C149.133 49.7168 148.436 48.2244 148.436 46.3288C148.436 44.2315 149.174 42.5778 150.732 41.4485C152.249 40.3192 154.464 39.7142 157.416 39.7142H162.706V38.4639C162.706 37.3345 162.296 36.4069 161.476 35.7615C160.656 35.1162 159.508 34.7532 158.072 34.7532C156.76 34.7532 155.694 35.0356 154.874 35.6002C154.29 36.002 153.873 36.4854 153.622 37.0506C153.442 37.4548 153.072 37.7782 152.623 37.7782H150.075C149.526 37.7782 149.091 37.3104 149.215 36.785C149.59 35.1959 150.473 33.9193 151.839 32.9786C153.48 31.8493 155.612 31.2443 158.277 31.2443C161.066 31.2443 163.239 31.8896 164.797 33.1802C166.315 34.4709 167.094 36.3262 167.094 38.7462V46.8934C167.094 47.8614 167.545 48.3454 168.488 48.3454ZM162.706 43.6668C162.706 43.2659 162.376 42.9408 161.968 42.9408H157.211C155.817 42.9408 154.792 43.2231 154.054 43.7475C153.316 44.2718 152.947 45.0381 152.947 46.0464C152.947 46.9338 153.275 47.6598 153.972 48.1841C154.669 48.7488 155.612 48.9908 156.842 48.9908C158.646 48.9908 160.082 48.5068 161.107 47.5388C162.132 46.5708 162.665 45.2801 162.706 43.6668Z"
        fill="url(#paint4_linear_2110_41942)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2110_41942"
          x1="169.349"
          y1="6.04736"
          x2="125.063"
          y2="116.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2110_41942"
          x1="169.349"
          y1="6.04736"
          x2="125.063"
          y2="116.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2110_41942"
          x1="169.349"
          y1="6.04736"
          x2="125.063"
          y2="116.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2110_41942"
          x1="169.349"
          y1="6.04736"
          x2="125.063"
          y2="116.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2110_41942"
          x1="169.349"
          y1="6.04736"
          x2="125.063"
          y2="116.025"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stop-color="#BFF4F3" />
          <stop offset="0.4" stop-color="#FAF6E2" />
          <stop offset="0.6" stop-color="#FEE69D" />
          <stop offset="0.9" stop-color="#FCC350" />
        </linearGradient>
      </defs>
    </symbol>
  </svg>
</template>
